export enum ValveCommand {
  FACTORY_RESET = 1,
  GET_STATUS = 2,
  REBOOT = 3
}
